"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultBenefitsDescriptionConfig = exports.defaultLayerConfig = exports.defaultItemIconConfig = void 0;
var defaultItemIconConfig = {
    margin: {
        desktop: '0 10px 0 0',
        tablet: '0 10px 0 0',
        mobile: '0 10px 0 0'
    }
};
exports.defaultItemIconConfig = defaultItemIconConfig;
var defaultLayerConfig = {
    padding: {
        desktop: '120px 15px 60px',
        tablet: '80px 0 60px',
        mobile: '80px 0 60px'
    }
};
exports.defaultLayerConfig = defaultLayerConfig;
var defaultBenefitsDescriptionConfig = {};
exports.defaultBenefitsDescriptionConfig = defaultBenefitsDescriptionConfig;
//# sourceMappingURL=ShortHeroHeader.js.map